var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _polygon, _path16, _polygon2, _path17, _polygon3, _circle, _path18, _path19, _path20, _path21, _path22, _polygon4, _path23, _polygon5, _path24, _path25, _polygon6, _polygon7, _circle2, _path26, _circle3, _path27, _path28, _path29, _path30, _path31, _rect, _rect2, _rect3, _path32, _path33, _rect4, _rect5, _rect6, _path34, _path35, _rect7, _rect8, _rect9, _path36, _polygon8, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesforceCommunities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 983.67538,
    height: 502.49722,
    viewBox: "0 0 983.67538 502.49722",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M788.72537,641.23089l-11.45152,18.00379,6.67024-23.43768c-14.08341-14.69525-33.58017-25.44536-33.58017-25.44536s-24.00721,39.456-17.5457,63.72679,23.14619,28.904,40.94491,24.16547c17.79842-4.73841,29.97087-17.05411,23.50936-41.32487C795.83429,651.51685,792.71014,646.21338,788.72537,641.23089Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M773.574,661.0293l.31849,1.19632c3.63109,13.925,4.17436,25.39935,1.60654,34.26447-.03518.12987-.07787.25539-.11309.38527l-.59881-.1767-.57354-.17712c2.90882-9.60917,1.6106-21.75146-1.55338-33.89806-.09814-.39248-.19785-.79085-.30942-1.18607-1.38481-5.1301-3.08146-10.24054-4.92823-15.1525-.1396-.38144-.2867-.7672-.4338-1.153-2.47108-6.47083-5.17131-12.56354-7.67291-17.81488-.17513-.372-.35619-.74236-.53567-1.10684-4.27074-8.87108-7.89115-15.15643-8.70464-16.54447-.09624-.171-.15268-.26377-.16491-.28587l.52007-.30971.00435-.0075.526-.31129c.01224.02213.20279.33292.53573.91656,1.25809,2.17657,4.59953,8.10492,8.45215,16.07257.172.36013.353.73054.52817,1.10248,2.03457,4.25945,4.19171,9.05072,6.24333,14.13642q.77615,1.9149,1.48483,3.79061c.153.38419.30009.76995.43969,1.1514Q771.6405,653.88577,773.574,661.0293Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M759.94889,625.74052c-.3826.159-.77113.31949-1.16875.46971a33.8107,33.8107,0,0,1-3.29457,1.06105,32.88922,32.88922,0,0,1-14.56639.55462c-.16518.38009-.33034.76022-.49986,1.14782a34.10716,34.10716,0,0,0,15.3816-.51794,34.98363,34.98363,0,0,0,3.51489-1.13871c.39169-.14868.78022-.30922,1.16125-.47407a33.81987,33.81987,0,0,0,8.68483-5.37544q-.51207-.38691-1.00167-.76078A32.77651,32.77651,0,0,1,759.94889,625.74052Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M768.20522,644.77q-.60353.19871-1.2165.36192c-.12281.039-.25309.07373-.37747.10684a33.06375,33.06375,0,0,1-29.87178-6.717c-.14386.41247-.28774.825-.42409,1.2418a34.29145,34.29145,0,0,0,30.61121,6.6597c.16585-.04415.33166-.0883.49593-.13838.413-.11629.81847-.23694,1.22239-.36348a34.11011,34.11011,0,0,0,15.92042-10.8344c-.28255-.29895-.5651-.59794-.85357-.89531A32.83671,32.83671,0,0,1,768.20522,644.77Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M773.574,661.0293c-.40508.1459-.81336.27995-1.22321.40811-.43946.136-.88049.26611-1.32468.38436a33.15318,33.15318,0,0,1-36.85066-14.87349c-.13879.55071-.27918,1.09546-.40612,1.643a34.36725,34.36725,0,0,0,37.57213,14.415c.44418-.11825.88679-.24243,1.31875-.38279.41735-.1238.82563-.25785,1.23228-.39786a34.26668,34.26668,0,0,0,19.01434-16.48453c-.24106-.40514-.49829-.79963-.7571-1.20005A33.04619,33.04619,0,0,1,773.574,661.0293Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M729.72537,231.23089l-11.45152,18.00379,6.67024-23.43768c-14.08341-14.69525-33.58017-25.44536-33.58017-25.44536s-24.00721,39.456-17.5457,63.72679,23.14619,28.90395,40.94491,24.16547c17.79842-4.73841,29.97087-17.05411,23.50936-41.32487C736.83429,241.51685,733.71014,236.21338,729.72537,231.23089Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#f2f2f2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M714.574,251.0293l.31849,1.19632c3.63109,13.925,4.17436,25.39935,1.60654,34.26447-.03518.12987-.07787.25539-.11309.38527l-.59881-.1767-.57354-.17712c2.90882-9.60917,1.6106-21.75146-1.55338-33.89806-.09814-.39248-.19785-.79085-.30942-1.18607-1.38481-5.1301-3.08146-10.24054-4.92823-15.1525-.1396-.38144-.2867-.7672-.4338-1.153-2.47108-6.47083-5.17131-12.56354-7.67291-17.81488-.17513-.372-.35619-.74236-.53567-1.10684-4.27074-8.87108-7.89115-15.15643-8.70464-16.54447-.09624-.171-.15268-.26377-.16491-.28587l.52007-.30971.00435-.0075.526-.31129c.01224.02213.20279.33292.53573.91656,1.25809,2.17657,4.59953,8.10492,8.45215,16.07257.172.36013.353.73054.52817,1.10248,2.03457,4.25945,4.19171,9.05072,6.24333,14.13642q.77615,1.9149,1.48483,3.79061c.153.38419.30009.77.43969,1.1514Q712.6405,243.88577,714.574,251.0293Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M700.94889,215.74052c-.3826.159-.77113.31949-1.16875.46971a33.8107,33.8107,0,0,1-3.29457,1.061,32.88922,32.88922,0,0,1-14.56639.55462c-.16518.38009-.33034.76022-.49986,1.14782a34.10716,34.10716,0,0,0,15.3816-.51794,34.98363,34.98363,0,0,0,3.51489-1.13871c.39169-.14868.78022-.30922,1.16125-.47407a33.81987,33.81987,0,0,0,8.68483-5.37544q-.51207-.38691-1.00167-.76078A32.77651,32.77651,0,0,1,700.94889,215.74052Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M709.20522,234.77q-.60353.19871-1.2165.36192c-.12281.039-.25309.07373-.37747.10684a33.06375,33.06375,0,0,1-29.87178-6.717c-.14386.41247-.28774.825-.42409,1.2418a34.29145,34.29145,0,0,0,30.61121,6.6597c.16585-.04415.33166-.0883.49593-.13838.413-.11629.81847-.23694,1.22239-.36348a34.11011,34.11011,0,0,0,15.92042-10.8344c-.28255-.29895-.5651-.59794-.85357-.89531A32.83671,32.83671,0,0,1,709.20522,234.77Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M714.574,251.0293c-.40508.1459-.81336.27995-1.22321.40811-.43946.136-.88049.26611-1.32468.38436a33.15318,33.15318,0,0,1-36.85066-14.87349c-.13879.55071-.27918,1.09546-.40612,1.643a34.36725,34.36725,0,0,0,37.57213,14.415c.44418-.11825.88679-.24243,1.31875-.38279.41735-.1238.82563-.25785,1.23228-.39786a34.26668,34.26668,0,0,0,19.01434-16.48453c-.24106-.40514-.49829-.79963-.7571-1.20005A33.04619,33.04619,0,0,1,714.574,251.0293Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M414.81971,671.45163l-21.33693.09672,23.32431-7.05648c4.75136-19.79184,3.25754-42.00574,3.25754-42.00574s-46.172,1.1284-63.09929,19.68338-11.80708,35.09668,1.8,47.51015c13.60687,12.41328,30.54787,15.99758,47.4752-2.55739C410.00823,682.99231,412.78159,677.49726,414.81971,671.45163Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#f2f2f2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M389.97306,669.40552l-.83436.91459c-9.75291,10.58159-19.11307,17.24072-27.95955,19.872-.12828.0406-.257.07253-.38526.11311l-.175-.59932-.161-.57827c9.65678-2.74659,19.17082-10.4019,27.68-19.62927.27717-.29471.55844-.59393.83065-.90141,3.56762-3.938,6.95015-8.12769,10.08455-12.33643.24547-.32362.49051-.65589.73556-.98816,4.10848-5.57658,7.775-11.14157,10.841-16.08467.2183-.34841.432-.70093.64168-1.04894,5.15516-8.38807,8.48637-14.83136,9.21447-16.266.09184-.17339.13939-.271.15138-.29326l.54167.27015.00867-.0004.5462.27429c-.012.02226-.17048.35056-.48156.94614-1.15122,2.23494-4.33285,8.25057-8.95392,15.79854-.21.33934-.4238.69189-.64208,1.04027-2.48391,4.014-5.349,8.41867-8.51886,12.89366q-1.19155,1.688-2.38661,3.29812c-.24054.33637-.48558.66864-.731.99227Q394.93811,663.91766,389.97306,669.40552Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M412.29823,638.86821c-.34054-.236-.68561-.47609-1.02691-.72943a33.8126,33.8126,0,0,1-2.67346-2.19833,32.88924,32.88924,0,0,1-8.34-11.95544c-.40906.06648-.81815.133-1.23589.19986a34.10717,34.10717,0,0,0,8.74973,12.66113,34.98256,34.98256,0,0,0,2.85789,2.34172c.3368.24918.68187.48929,1.02651.72076a33.81967,33.81967,0,0,0,9.21682,4.40135q.04873-.63995.09865-1.25394A32.77657,32.77657,0,0,1,412.29823,638.86821Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M400.75068,656.10026q-.4934-.40037-.962-.82787c-.09923-.08222-.19883-.17308-.29392-.25983a33.06375,33.06375,0,0,1-10.49485-28.76282c-.42478.10192-.84962.20383-1.274.31441a34.29146,34.29146,0,0,0,10.94274,29.354c.12679.11567.25355.23131.38447.34244.32106.28459.64174.56054.96654.832a34.11018,34.11018,0,0,0,17.72055,7.53827c.0988-.3993.19762-.79863.29189-1.20207A32.83677,32.83677,0,0,1,400.75068,656.10026Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M389.97306,669.40552c-.3417-.262-.67516-.533-1.00451-.80854-.352-.29623-.69981-.59695-1.03939-.90675a33.15316,33.15316,0,0,1-7.40468-39.04308c-.53836.18089-1.07255.35722-1.60181.54636a34.36723,34.36723,0,0,0,8.18038,39.40227c.33958.30979.68329.615,1.03485.90261.32975.28422.66321.55526,1.0008.82172a34.26677,34.26677,0,0,0,24.14653,7.08733c.21056-.4218.40343-.85145.60042-1.28563A33.04621,33.04621,0,0,1,389.97306,669.40552Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "235.821 489.442 248.081 489.441 253.913 442.153 235.819 442.154 235.821 489.442",
    fill: "#ffb6b6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M340.8563,684.19054l24.144-.001h.001a15.3873,15.3873,0,0,1,15.38647,15.38623v.5l-39.53076.00147Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "138.821 489.442 151.081 489.441 156.913 442.153 138.819 442.154 138.821 489.442",
    fill: "#ffb6b6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M243.8563,684.19054l24.144-.001h.001a15.3873,15.3873,0,0,1,15.38647,15.38623v.5l-39.53076.00147Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "159.613 295.2 151.35 302.805 142.037 394.681 135.768 467.838 154.713 470.393 200.665 345.394 234.288 469.8 256.956 470.393 241.911 308 159.613 295.2",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 199.54384,
    cy: 135.80949,
    r: 23.53627,
    fill: "#ffb9b9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M295.661,323.63232s-2.806,6.07251,8.418,3.64353c0,0,4.209,2.429,4.209-1.21451,0,0,5.612,6.07251,7.015,2.429s4.209,1.21451,4.209,1.21451l2.806-6.07251,2.806,3.64353h9.821s2.806-24.29007-30.866-21.86106S286.97186,346.329,286.97186,346.329s.27115-6.90814,3.07715-3.26462S295.661,323.63232,295.661,323.63232Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M325.63943,365.77871,292.45068,363.701l-29.57553,7.84543,4.48306,76.21267L259.5128,501.5563s43.04425,26.31244,91.90352,5.60388l-4.64073-12.20855s-.15967-18.685-4.07984-22.34252-3.60792-33.81614-3.60792-33.81614l14.57007-56.03876Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M270.77559,373.95163l-7.90044-2.40518s-12.30428.41077-18.70192,14.408-10.39764,33.99721-10.39764,33.99721l40.63386,1.4693Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M365.091,507.5574l-1.31543-82.60577-17.55518,2.63354,3.87745,78.26343a10.50962,10.50962,0,1,0,14.99316,1.7088Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#ffb9b9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M343.77559,389.95163l9.88231-7.19742s18.98881,14.851,19.05325,47.52419l-26.49068,6.4252-14.978-21.54331Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#3f3d56"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "768.569 489.395 780.829 489.394 786.661 442.106 768.567 442.107 768.569 489.395",
    fill: "#9e616a"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M873.60433,684.14329l24.144-.001h.001a15.3873,15.3873,0,0,1,15.38648,15.38623v.5l-39.53077.00146Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#2f2e41"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "696.005 478.969 707.694 482.667 727.517 439.34 710.266 433.883 696.005 478.969",
    fill: "#9e616a"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M802.39283,672.96121l23.01994,7.2813.00093.00029a15.3873,15.3873,0,0,1,10.02918,19.3105l-.1508.47671L797.60184,688.1083Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#2f2e41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M831.77165,472.17637,824.9685,491.3641l-.19291,103.58753L805.48221,665.8741l23.68341,6.60957,26.16119-66.87353,8.39118-58.73829,11.0576,59.07978-1.522,70.22047h24.84882l1.8757-108.21052a237.255,237.255,0,0,0-15.66344-88.98189l0,0Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#2f2e41"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "715.507 195.7 755.672 195.7 772.454 212.483 777.468 281.854 716.806 291.615 697.32 225.426 707.932 197.295 715.507 195.7",
    fill: "#ff9f00"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "701.063 226.088 639.223 202.821 637.613 193.203 676.613 160.203 689.594 169.939 666.066 195.7 707.932 197.295 701.063 226.088",
    fill: "#ff9f00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 684.11328,
    cy: 163.70024,
    r: 10,
    fill: "#9e616a"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M815.46744,375.04955l4.51872-20.37607A27.96728,27.96728,0,0,1,874.594,366.78365l-4.51872,20.37608a3.761,3.761,0,0,1-4.48106,2.85432l-47.27249-10.48344A3.761,3.761,0,0,1,815.46744,375.04955Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.72959,
    cy: 164.28406,
    r: 20.50463,
    fill: "#9e616a"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M813.16521,354.87108a22.14839,22.14839,0,0,1,26.38848-16.80879l4.07541.90378a22.14824,22.14824,0,0,1,16.8086,26.38844l-.09038.40752-8.61227-1.90991-1.11334-8.87666-2.41148,8.095-4.4509-.98706-.56171-4.4787L841.9808,361.689l-28.906-6.41036Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#2f2e41"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M833.86911,385.38249a3.70119,3.70119,0,0,1,.56366-3.9001c6.14018-7.2564,15.55266-21.09326,9.60258-32.23338l-.4277-.8005,23.3,5.16714-7.75773,34.98158-21.99444-.9594a3.83828,3.83828,0,0,1-.6618-.08664A3.74174,3.74174,0,0,1,833.86911,385.38249Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#2f2e41"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.647,701.24861H109.353a1.19069,1.19069,0,0,1,0-2.38137h981.294a1.19068,1.19068,0,0,1,0,2.38137Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#cacaca"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M604.12139,406.47205H286.80645a18.34252,18.34252,0,0,0-18.34253,18.34253v76.31494a18.34248,18.34248,0,0,0,18.34253,18.34253h4.65747v13.7876a4.23013,4.23013,0,0,0,7.22131,2.99108l16.77869-16.77868H604.12139a18.34248,18.34248,0,0,0,18.34253-18.34253V424.81458A18.34252,18.34252,0,0,0,604.12139,406.47205Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#e6e6e6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M527.80664,509.97168h-241a8.85271,8.85271,0,0,1-8.84277-8.84277V424.81445a8.8525,8.8525,0,0,1,8.84228-8.84228H604.12109a8.85272,8.85272,0,0,1,8.84278,8.84277A85.25331,85.25331,0,0,1,527.80664,509.97168Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 264.63494,
    y: 233.72066,
    width: 146,
    height: 12,
    rx: 5.99999,
    fill: "#ff9f00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 236.13494,
    y: 257.72066,
    width: 203,
    height: 12,
    rx: 5.99999,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 236.13494,
    y: 281.72066,
    width: 203,
    height: 12,
    rx: 5.99999,
    fill: "#e6e6e6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.19926,459.60844H826.72857a13.26464,13.26464,0,0,0-13.26465,13.26465V528.0613A13.26461,13.26461,0,0,0,826.72857,541.326h3.36812v9.9707a3.05907,3.05907,0,0,0,5.22219,2.163L847.45262,541.326h208.74664a13.26461,13.26461,0,0,0,13.26466-13.26465V472.87309A13.26464,13.26464,0,0,0,1056.19926,459.60844Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#e6e6e6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.19922,534.59473H826.72852a6.54046,6.54046,0,0,1-6.53321-6.53321V472.87305a6.54046,6.54046,0,0,1,6.53321-6.53321h174.2832a61.79107,61.79107,0,0,1,61.7207,61.72168A6.54045,6.54045,0,0,1,1056.19922,534.59473Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 780.7517,
    y: 279.65931,
    width: 105.58192,
    height: 8.67797,
    rx: 4.33898,
    fill: "#ff9f00"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 760.14153,
    y: 297.01524,
    width: 146.80226,
    height: 8.67797,
    rx: 4.33898,
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 760.14153,
    y: 314.37118,
    width: 146.80226,
    height: 8.67797,
    rx: 4.33898,
    fill: "#e6e6e6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M566.72857,265.60844H796.19926a13.26464,13.26464,0,0,1,13.26466,13.26465V334.0613A13.26461,13.26461,0,0,1,796.19926,347.326h-3.36811v9.9707a3.05907,3.05907,0,0,1-5.22219,2.163L775.47522,347.326H566.72857a13.26461,13.26461,0,0,1-13.26465-13.26465V278.87309A13.26464,13.26464,0,0,1,566.72857,265.60844Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#e6e6e6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M796.19922,340.59424H621.917a61.79138,61.79138,0,0,1-61.72168-61.7207,6.54088,6.54088,0,0,1,6.53321-6.5337h229.4707a6.54045,6.54045,0,0,1,6.5332,6.53321v55.188A6.54045,6.54045,0,0,1,796.19922,340.59424Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 628.4319,
    y: 284.4107,
    width: 105.58192,
    height: 8.67797,
    rx: 4.33898,
    transform: "translate(1254.28342 378.74798) rotate(180)",
    fill: "#ff9f00"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 607.82173,
    y: 301.76663,
    width: 146.80226,
    height: 8.67797,
    rx: 4.33898,
    transform: "translate(1254.28342 413.45984) rotate(180)",
    fill: "#e6e6e6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 607.82173,
    y: 319.12256,
    width: 146.80226,
    height: 8.67797,
    rx: 4.33898,
    transform: "translate(1254.28342 448.17171) rotate(180)",
    fill: "#e6e6e6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M302.27559,404.95163a10.5,10.5,0,0,0-21,0c0,.10248.01221.20178.01514.30359L262.8752,423.67093l1.40039-3.2193-21-1-3.06348,22.172a9.969,9.969,0,0,0,16.78174,8.49377l36.3003-34.7879A10.49311,10.49311,0,0,0,302.27559,404.95163Z",
    transform: "translate(-108.16231 -198.75139)",
    fill: "#ffb9b9"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "754.074 196.12 819.488 205.421 823.145 214.461 792.231 255.134 777.448 248.445 794.828 218.194 753.613 225.718 754.074 196.12",
    fill: "#ff9f00"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.11328,
    cy: 256.70024,
    r: 10,
    fill: "#9e616a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesforceCommunities);
export default __webpack_public_path__ + "static/media/SALESFORCE_COMMUNITIES.07e7600c52ddd765d38d7fbff43c6968.svg";
export { ForwardRef as ReactComponent };